import { render, staticRenderFns } from "./Footerend.vue?vue&type=template&id=1093df08&scoped=true"
import script from "./Footerend.vue?vue&type=script&lang=js"
export * from "./Footerend.vue?vue&type=script&lang=js"
import style0 from "./Footerend.vue?vue&type=style&index=0&id=1093df08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1093df08",
  null
  
)

export default component.exports